import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";

const ThemeContext = createContext({ theme: "light", toggleTheme: () => {}, setTheme: () => {} });

function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "light") root.classList.add("light");
  else root.classList.remove("light");
}

export function ThemeProvider({ children }) {
  const auth = useAuth();
  const user = auth?.user;

  const [theme, setThemeState] = useState(() => {
    try {
      return localStorage.getItem("theme") === "dark" ? "dark" : "light";
    } catch {
      return "light";
    }
  });

  // Global policy: logged-out users ALWAYS see light mode everywhere.
  // Dark mode only applies inside the app when a logged-in user has chosen it.
  const effective = user ? theme : "light";

  useEffect(() => {
    applyTheme(effective);
  }, [effective]);

  useEffect(() => {
    try {
      localStorage.setItem("theme", theme);
    } catch {
      /* storage may be blocked */
    }
  }, [theme]);

  const setTheme = useCallback((t) => setThemeState(t === "light" ? "light" : "dark"), []);
  const toggleTheme = useCallback(() => setThemeState((t) => (t === "light" ? "dark" : "light")), []);

  return (
    <ThemeContext.Provider value={{ theme: effective, toggleTheme, setTheme }}>{children}</ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
